import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { Company, CompanyFilters } from '../models/company.model';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { CompaniesResponse } from '../models/companies.model';

interface CompaniesServiceData {
  searchQuery: string;
}

@Injectable()
export class CompaniesService {
  public serviceData: CompaniesServiceData = null;
  public previousUrl: string;

  constructor(
    private http: HttpClient,
    private router: Router
    ) {
      this.router.events.pipe(filter(e => e instanceof RoutesRecognized), pairwise())
      .subscribe((event: any[]) => {
        if(!event[0].urlAfterRedirects.includes('/dashboard/companies')) {
          this.setData(null);
        }
      });
  }

  getCompaniesBySearch(keyword: string): Observable<Company[]> {
    return this.http.get<Company[]>(`${environment.apiEndpoint}/api/v2/companies?search=${keyword}`);
  }

  getCompaniesByFilters(idPage: any, size: any, filters: CompanyFilters): Observable<CompaniesResponse> {
    let params = new HttpParams()
    .append('page', idPage)
    .append('size', size);
    if (filters && filters.alphaname) {
      params = params.append('alphaname', filters.alphaname);
    }
    if (filters && filters.did) {
      params = params.append('number', filters.did);
    }
    if (filters && filters.id) {
      params = params.append('company_id', filters.id);
    }
    if (filters && filters.billingId) {
      params = params.append('billing_id', filters.billingId);
    }
    if (filters && filters.name) {
      params = params.append('name', filters.name);
    }
    if (filters && filters.email) {
      params = params.append('email', filters.email);
    }
    return this.http.get<CompaniesResponse>(`${environment.apiEndpoint}/api/v2/companies/search`, { params })
  }

  public setData(companiesSearch: CompaniesServiceData) {
    this.serviceData = companiesSearch;
  }

  public getData() {
    return this.serviceData;
  }

}
